import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import PropTypes from "prop-types";

function MultipleRadioBtnField({
  name,
  rules,
  questions,
  className,
  optionsClassName,
  parentClassName,
  questionKey,
  answerKey
}) {
  const {
    control,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();

  const handleSelect = (qnId, optId) => {
    // console.log(qnId, optId);
    const preValue = watch(name);
    // console.log(questionKey);
    
    const newEntry = {
      [questionKey || 'question_id']: qnId,
      [answerKey || 'is_selected_as']: optId,
    };

    const existingIndex = preValue.findIndex(
      (item) => item[questionKey || 'question_id'] === qnId
    );

    if (existingIndex >= 0) {
      preValue[existingIndex] = newEntry;
    } else {
      preValue.push(newEntry);
    }
    // console.log(preValue);
    setValue(name, preValue);
  };

  return questions.map((question, index) => (
    <div key={question.id} className={className}>
      <label htmlFor={`${name}-${question.id}`} className="form-label mb-3">
        {question.name}
      </label>

      <Controller
        name={`${name}-${question.id}`}
        control={control}
        defaultValue=""
        rules={rules}
        render={({ field }) => (
          <div className={`${parentClassName || 'row'}`}>
            {question?.options?.map((option) => (
              <div 
                key={index} 
                className={`${optionsClassName || (parentClassName ? '' : 'col-md-4')} me-3  mb-3`}
              >
                <div className="form-check form-checked">
                  <input
                    {...field}
                    type="radio"
                    value={option.id}
                    className="form-check-input"
                    id={`${name}-${question.id}-radio-${option.id}`}
                    onChange={() => {
                      field.onChange(option.id);
                      handleSelect(question.id, option.id);
                    }}
                    checked={field.value === option.id}
                  />
                  {option.name && (
                    <label
                      className="form-check-label ms-1 account-access"
                      htmlFor={`${name}-${question.id}-radio-${option.id}`}
                    >
                      {option.name}
                    </label>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      />

      {errors[`${name}.${question.id}`] && (
        <span className="error">
          {errors[`${name}-${question.id}`].message}
        </span>
      )}
    </div>
  ));
}

MultipleRadioBtnField.propTypes = {
  name: PropTypes.string.isRequired,
  rules: PropTypes.object,
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
            .isRequired,
          name: PropTypes.string.isRequired,
        })
      ),
    })
  ).isRequired,
  className: PropTypes.string,
  optionsClassName: PropTypes.string,
};

export default MultipleRadioBtnField;
